import { useNode } from '@craftjs/core';
import cx from 'classnames';
import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import {
  TextArea as KendoTextArea,
} from "@progress/kendo-react-inputs";
import { TextAreaSettings } from './TextAreaSettings';
import { Text } from '../Text';
import { FormContext } from '../../../context/form';
import evaluateVisibility from '../../utils/evaluateVisibility';
import FieldLabel from '../../../FieldLabel';

const StyledTextArea = styled.div`
  margin: ${({ margin = [] }) =>
    `${margin[0]}px ${margin[1]}px ${margin[2]}px ${margin[3]}px`};
`;

export const TextArea = (props) => {
  const {
    connectors: { connect },
  } = useNode((node) => ({
    selected: node.events.selected,
  }));

  // Consume form values from the provider.
  // It makes selector components tightly coupled with the parent,
  // but this is by far the most efficient way of doing it.
  const { state, recordState } = useContext(FormContext)
  const [recordDetail] = recordState
  const [values, setValues] = state

  const {
    margin,
    textComponent,
    id,
    label: text,
    visibility = [],
    disabled,
    tabID,
    required,
    ...otherProps
  } = props;

  const { isVisible } = evaluateVisibility({ values, visibility, tabID, recordDetail })

  const handleOnChange = (e) => {
    // if(id === "user_group"){
    //   if(values.source_of_observation !== undefined){
    //     setValues({
    //     ...values,
    //     [id]: e.target.value,
    //        source_of_observation: ""
    //     })
    //   }
    //   else{
    //   setValues({
    //     ...values,
    //     [id]: e.target.value,
    //   })
    // }
    // }else{
      console.log(e, id, "checkthis one");

    if (values.ohs) {
      console.log("this one");
      if (props.tabID >= 1) {
      console.log("this one1", values.ohs.length, props.tabID);

        if (values.ohs.length < props.tabID) {
          setValues({
            ...values,
            ohs: [...values.ohs, { [id]: e.target.value }]
          })
        } else {
          console.log("this one is checker", values.ohs[props.tabID - 1]?.[id]);

          if (values.ohs[props.tabID - 1]?.[id]) {
            let update = values.ohs[props.tabID - 1]
            update[id] = e.target.value
            setValues({
              ...values
            })
          } else {
            values.ohs[props.tabID - 1][id] = e.target.value
            console.log("this one2");
           console.log(values.ohs[props.tabID - 1]);
            setValues({
              ...values,
            })
          }
        }
      }
    } else {
      console.log("this one4");

      if (props.tabID > 0) {
      console.log("this one5");

        setValues({
          ...values,
          ohs: [{
            [id]: e.target.value
          }]
        })
      } else {
      console.log("this one6");


        setValues({
          ...values,
          [id]: e.target.value,
        })
      }
      // }
    }
  }
  useEffect(() => {
    if (!isVisible()) {
      if (values.ohs) {
        if (values.ohs[props.tabID - 1] && values.ohs[props.tabID - 1][id]) {
          delete values.ohs[props.tabID - 1][id]

          setValues({
            ...values
          })
        }
      }
    }
    if (required && isVisible()) {
      const cases =
        values.ohs === undefined
          ? true
          : values.ohs[props.tabID - 1] &&
            values.ohs[props.tabID - 1][id] !== undefined
            ? values.ohs[props.tabID - 1][id] === ""
              ? true
              : false
            : true;
      if (cases === true) {
        props.checkValidation(true, `${id} ${props.tabID}`)
      } else {
        props.checkValidation(false, `${id} ${props.tabID}`)
      }
    }
    if(required && !isVisible()){
      props.checkValidation(false, `${id} ${props.tabID}`)
    }
  })
  const getVisible = () => {
    if(props.detail){
      return props.show
    }else{
      return isVisible()
    }
  }

  return getVisible()
    ? (
      <StyledTextArea
        ref={connect}
        className={cx([
          'w-full detail-item-box field-validation__wrapper',
        ])}
        margin={margin}
      >
        <FieldLabel {...textComponent} text={text} required={props.isMandaotry ? props.isMandaotry : required} />
        <KendoTextArea
          {...otherProps}
          rows={5}
          height={110}
          autoSize={false}
          className={cx([
            'w-full work-textbox !h-[110px]',
          ])}
          // onChange={e => {
          //   setValues({
          //     ...values,
          //     [id]: e?.target?.value,
          //   })
          // }}
          onChange={handleOnChange}
          // value={values?.[id]}
          value={props.value ? props.value : props.tabID >= 1 && values.ohs && values.ohs[props.tabID - 1]?.[id]}
          disabled={disabled}
          resizable="none"
        />
        {required && props.tabID >= 1 && (
          <>
            {values.ohs === undefined ? (<div className='OHS_FORM_validation'>
              This field is required!</div>) : values.ohs && (values.ohs[props.tabID - 1]?.[id] === undefined || values.ohs[props.tabID - 1]?.[id] === "") && (<div className='OHS_FORM_validation'>
                This field is required!</div>)}
          </>
        )}
      </StyledTextArea>
    )
    : null
};

TextArea.craft = {
  displayName: 'Text Area',
  props: {
    margin: ['5', '0', '5', '0'],
    placeholder: 'Enter a value...',
    id: '',
    text: 'Field label',
    textComponent: {
      ...Text.craft.props,
    },
  },
  related: {
    toolbar: TextAreaSettings,
  },
};
